import { Box, Button, Flex, grid, Grid, GridItem, Heading, Image, SimpleGrid, Text } from "@chakra-ui/react";

import html from "../Assert/skills/html-5-240.png"
import js from "../Assert/skills/javascript-240.png"
import css from "../Assert/skills/css3-240.png"
import sass from "../Assert/skills/sass-240.png"
import ts from "../Assert/skills/typescript-240.png"
import react from "../Assert/skills/react-240.png"
import redux from "../Assert/skills/redux-240.png"
import ex from "../Assert/skills/express-js-240.png"
import nodejs from "../Assert/skills/node-js-240.png"
import mongo from "../Assert/skills/mongodb-96.png"
import chakra from "../Assert/skills/chakra-ui-240.png"
import gitbash from "../Assert/skills/git-240.png"
import github from "../Assert/skills/github-240.png"
import swift from "../Assert/skills/swift-240.png"

import "./Skills.css"

const Skills = () => {
  
  return (
    <>
     <hr className="hrClass" style={{
      height:5,
      backgroundColor:'#29242a'
    }}/>
    <Box  id='skills' className="skills"  bg={'#796a53'}  pt={"4rem"} color={'white'}>
    <Box >
        <Box>
             <Heading textDecoration={'underline'} fontSize={50} textUnderlineOffset='10px' textDecorationStyle={'solid'} textDecorationColor={'orange'} color={'#15110D'}>Technical Skills </Heading><br/> 
        </Box>
        

            <div className="skillFlex">
                <div className="skillGrid" >
                    <div  className="skillSet" >
                        <img className="skillImg" src={html} alt="html"/>
                        <Text fontSize={25}>HTML</Text>
                    </div>

                    <div  className="skillSet" >
                        <img className="skillImg" src={js} alt="js"/>
                        <Text fontSize={25}>Java-Script</Text>
                    </div>

                    <div  className="skillSet" >
                        <img className="skillImg" src={css} alt="css"/>
                        <Text fontSize={25}>CSS</Text>
                    </div>

                    <div  className="skillSet" >
                        <img className="skillImg" src={ts} alt="ts"/>
                        <Text fontSize={25}>Type-Script</Text>
                    </div>

                    <div  className="skillSet" >
                        <img className="skillImg" src={react} alt="react"/>
                        <Text fontSize={25}>React</Text>
                    </div>
                    
                    <div  className="skillSet" >
                        <img className="skillImg" src={redux} alt="redux"/>
                        <Text fontSize={25}>Redux</Text>
                    </div>

                     {/* <Flex flexDirection={'column'} alignItems='center' borderRadius={'10px'} backgroundColor="#d6d0c9" border={'10px solid  #3b3228'} boxShadow={'0px 0px 15px  #3b3228'} color={'#15110D'}>
                        <Image w={'50%'} src={sass} alt="sass"/>
                        <Text fontSize={25}>Sass</Text>
                    </Flex> */}

                    <div className="skillSet" >
                        <img className="skillImg" src={'https://i0.wp.com/blog.knoldus.com/wp-content/uploads/2022/03/cypress.png?fit=364%2C364&ssl=1'} alt="cypress"/>
                        <Text fontSize={25}>Cypress</Text>
                    </div>
                    
                    <div className="skillSet" >
                        <img className="skillImg" src={ex} alt="ex"/>
                        <Text fontSize={25}>Express-JS</Text>
                    </div>

                     <div className="skillSet" >
                        <img className="skillImg" src={nodejs} alt="nodejs"/>
                        <Text fontSize={25}>Node-JS</Text>
                    </div>

                     <div className="skillSet" >
                        <img className="skillImg" src={gitbash} alt="gitbash"/>
                        <Text fontSize={25}>GitBash</Text>
                    </div>


                    <div className="skillSet" >
                        <img className="skillImg"  src={github} alt="github"/>
                        <Text fontSize={25}>Github</Text>
                    </div>

                    <div className="skillSet" >
                        <img className="skillImg" src={mongo} alt="mongodb"/>
                        <Text fontSize={25}>MongoDB</Text>
                    </div>

                    <div className="skillSet" >
                        <img className="skillImg"  src={chakra} alt="chakra"/>
                        <Text fontSize={25}>Chakra-Ui</Text>
                    </div>

                    <div className="skillSet" >
                        <img className="skillImg"  src={swift} alt="swift"/>
                        <Text fontSize={25}>Swift</Text>
                    </div>
                </div>
            </div>
        {/* </Flex> */}
      
    </Box><br /><br />
    </Box>
    </>
   
  )
}



export default Skills;